import { useEffect, useState } from "react";
import { rafThrottle } from "../utils/rafThrottle";

/**
 * @param {{ id: string }[]} sections
 * @param {{ scrollThreshold?: number; activeViewportRatio?: number }} options
 */
export function useSiteNavScroll(
  sections,
  { scrollThreshold = 24, activeViewportRatio = 0.22 } = {}
) {
  const [scrolled, setScrolled] = useState(false);
  const [activeId, setActiveId] = useState(sections[0]?.id ?? "");

  useEffect(() => {
    const sync = () => {
      setScrolled(window.scrollY > scrollThreshold);

      const offset = window.scrollY + window.innerHeight * activeViewportRatio;
      let current = sections[0]?.id ?? "";
      for (const { id } of sections) {
        const el = document.getElementById(id);
        if (!el) continue;
        const top = el.getBoundingClientRect().top + window.scrollY;
        if (top <= offset) current = id;
      }
      setActiveId(current);
    };

    const onScrollOrResize = rafThrottle(sync);
    sync();
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    return () => {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, [sections, scrollThreshold, activeViewportRatio]);

  return { scrolled, activeId };
}
